

import React,  { useRef } from "react";
import headerImage from "../../assets/header4.jpg";
import { CopyBlock, dracula } from "react-code-blocks";
import w10_1 from "../../assets/w10_1.jpg";
import w10_2 from "../../assets/w10_2.jpg";
import output from "../../assets/output.mp4";
import w10_3 from "../../assets/w10_3.jpg";


const Assignment14 = () => {
  const i2c = useRef(null);
  const display = useRef(null);
  const motordriver = useRef(null);

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };


    
  return (

    <div className="container mx-auto my-8 px-5 max-w-3xl bg-gray-100 p-8 rounded-lg shadow-md">
      {/* Header */}
      <div className="relative mb-8">
        <img
          src={headerImage}
          alt="Header"
          className="w-full h-64 object-cover rounded-lg shadow-md  object-cover filter grayscale brightness-75"
        />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4 rounded-b-lg">
          <h1 className="text-4xl font-bold text-bg-secondary"  style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 1)' }}>Week 13: Molding and Casting</h1>
          <p className="text-gray-300 mt-2">Published on: <span className="font-semibold">Mai 24, 2025</span></p>
          <div className="mt-4 flex space-x-4">
         {/* Navigation Links */}


        </div>
        </div>
        </div>
        <p className="text-justify text-gray-700 mb-6">
  In this week’s assignment, the focus was on <strong>output devices</strong> ...</p>
<div className="text-gray-700 space-y-4 mt-6">

<p className="text-justify text-gray-700 mb-6">
  The goal was to connect and control at least one output device using a board we previously designed or modified. In my case, I continued working with my custom ESP32S3 Plus-based development board and chose to explore an <strong>I2C LCD display</strong> as an output device. 
</p>


        <p className="text-justify text-gray-700 mb-6">
        ...</p>

        <p className="text-justify text-gray-700 mb-6">
        ...</p>
        <p className="text-justify text-gray-700 mb-6">
         ...</p>
        <p className="text-justify text-gray-700 mb-6">
         ...</p>



        {/* XYZ Section*/}
        <div ref={motordriver}></div>
        <h2 className="text-2xl font-bold text-left mb-2">Title 1</h2>
        <p className="text-justify text-gray-700 mb-6">

...
      </p>
      <img src={w10_3} alt="" className="my-4 mx-auto rounded shadow-md" />
      <h2 className="text-2xl font-bold text-left mb-2">Downloads</h2>

      <a
    style={{ display: "block" }}
    href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/Ultrasonic_Sketch_with_Display.ino"
    download
  >
    📎 Download Code
  </a>
        </div>

</div>

  );
};

export default Assignment14;
